var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"practice-dropdown-menu-item",class:{
    'practice-dropdown-menu-item--active': _vm.customStore.filterActive(_vm.value)
  },on:{"click":function($event){$event.preventDefault();return _vm.toggleFilter()}}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }